export default function VocabularyWordCard({
  term,
  translations = {},
  progress = null,
  getMasteryLabel,
  vocabularyLanguage,
}) {
  // =========================================================
  // PROGRESS VALUES
  // =========================================================

  const masteryLevel = progress?.mastery_level ?? 0;

  const masteryLabel = getMasteryLabel
    ? getMasteryLabel(masteryLevel)
    : masteryLevel === 3
    ? "Mastered"
    : masteryLevel === 2
    ? "Familiar"
    : masteryLevel === 1
    ? "Learning"
    : "New";

  const reviewCount = progress?.review_count ?? 0;

  const correctCount = progress?.correct_count ?? 0;

  const accuracy =
    reviewCount > 0
      ? Math.round(
          (correctCount / reviewCount) * 100
        )
      : null;

  // =========================================================
  // NEXT REVIEW
  // =========================================================

  const getNextReviewText = () => {
    if (!progress?.next_review_at) {
      return "Not scheduled";
    }

    const reviewDate = new Date(
      progress.next_review_at
    );

    const now = new Date();

    if (reviewDate <= now) {
      return "Due now";
    }

    return reviewDate.toLocaleDateString();
  };

  // =========================================================
  // MASTERY BADGE STYLE
  // =========================================================

  const getMasteryBadgeStyle = () => {
    const baseStyle = {
      display: "inline-block",
      padding: "4px 9px",
      borderRadius: "999px",
      fontSize: "12px",
      fontWeight: "700",
    };

    switch (masteryLevel) {
      case 1:
        return {
          ...baseStyle,
          backgroundColor: "#fef3c7",
          color: "#92400e",
        };

      case 2:
        return {
          ...baseStyle,
          backgroundColor: "#dbeafe",
          color: "#1d4ed8",
        };

      case 3:
        return {
          ...baseStyle,
          backgroundColor: "#dcfce7",
          color: "#166534",
        };

      default:
        return {
          ...baseStyle,
          backgroundColor: "#f3f4f6",
          color: "#4b5563",
        };
    }
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {/* =====================================================
          WORD HEADER
      ===================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "12px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "700",
            }}
          >
            {term.english_term}
          </div>

          {term.part_of_speech && (
            <div
              style={{
                marginTop: "4px",
                color: "#6b7280",
                fontSize: "14px",
              }}
            >
              {term.part_of_speech}
            </div>
          )}
        </div>

        <div style={getMasteryBadgeStyle()}>
          {masteryLabel}
        </div>
      </div>

      {/* =====================================================
          TRANSLATIONS
      ===================================================== */}

      <div
        style={{
          marginTop: "14px",
        }}
      >
        {translations[vocabularyLanguage] && (
          <div style={{ marginTop: "12px" }}>
            <strong>
              {vocabularyLanguage === "zh"
                ? "中文："
                : vocabularyLanguage === "es"
                ? "Español: "
                : "Русский: "}
            </strong>

            {translations[vocabularyLanguage]}
          </div>
        )}
      </div>

      {/* =====================================================
          WORD METADATA
      ===================================================== */}

      {term.frequency_level && (
        <div
          style={{
            marginTop: "12px",
            fontSize: "13px",
            color: "#6b7280",
          }}
        >
          Frequency: {term.frequency_level}
        </div>
      )}

      {/* =====================================================
          STUDY PROGRESS
      ===================================================== */}

      <div
        style={{
          marginTop: "16px",
          paddingTop: "14px",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <div
          style={{
            fontSize: "13px",
            fontWeight: "700",
            marginBottom: "10px",
          }}
        >
          Study Progress
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(110px, 1fr))",
            gap: "12px",
          }}
        >
          {/* Reviews */}

          <div>
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              Reviews
            </div>

            <div
              style={{
                marginTop: "3px",
                fontWeight: "600",
              }}
            >
              {reviewCount}
            </div>
          </div>

          {/* Accuracy */}

          <div>
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              Accuracy
            </div>

            <div
              style={{
                marginTop: "3px",
                fontWeight: "600",
              }}
            >
              {accuracy === null
                ? "—"
                : `${accuracy}%`}
            </div>
          </div>

          {/* Next Review */}

          <div>
            <div
              style={{
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              Next Review
            </div>

            <div
              style={{
                marginTop: "3px",
                fontWeight: "600",
              }}
            >
              {getNextReviewText()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}